import { store } from '@Redux/store';

export const getLayoutDirection = (): types.redux.settings.layout => {
	return store.getState().settings.layout;
};
